<section
  class="hero is-fullheight has-navbar-fixed-top"
  style="margin-top: -52px;"
>
  <div class="hero-body">
    <div class="container">
      <h1 class="title">404</h1>
      <h2 class="subtitle">Sorry, that page doesn't exist!</h2>
    </div>
  </div>
</section>
